// extracted by mini-css-extract-plugin
export default {"counter":"counter_counter__+HDvv","counterInput":"counter_counterInput__pBiBL","actionbutton":"counter_actionbutton__veAx-"};